angular
  .module('newDatepicker.components', [])
  .component('newDatepicker', {
    templateUrl: 'ng/components/newDatepicker/newDatepicker.html',
    bindings: {
      language: '@',
      inputPlaceholder: '@',
      inputId: '@',
      inputName: '@',
      inputClass: '@',
      bindingVariable: '<',
      startDate: '<',
      endDate: '<',
      stringDate: '@',
      disabledDays: '<',
      disabledDates: '<',
      disableHolidays: '<',
      changeData: '&',
      inputTabindex: '@',
      reinitializeOnClick: '<',
      restrictData: '<',
      inputNotRequired: '<',
      disabledDatepicker: '<',
      formName: "="
    },
    controllerAs: 'datepickerCtrl',
    controller: function ($scope, $timeout) {

      //Not to loose the *this reference
      var self = this;
      self.lang = "it";

      self.$onInit = function () {
        self.lang = self.language;
        self.dataRegex = /\d*([\/\.\-]?\d+)/;
        self.supportModel = {
          data: null
        }
        if (self.startDate === 'today') {
          self.startDate = moment().format("DD/MM/YYYY");
        }
        if (self.endDate === 'today') {
          self.endDate = moment().format("DD/MM/YYYY");
        }
        if (self.endDate === 'tomorrow') {
          self.endDate = moment().add(1, 'days').format("DD/MM/YYYY");
        }
        self.startDate = self.startDate || '';
        self.endDate = self.endDate || '';
        self.stringDate = self.stringDate || '';
        self.disabledDays = self.disabledDays || '';
        self.disabledDates = self.disabledDates || [];
        self.disableHolidays = self.disableHolidays || false;
        self.reinitializeOnClick = self.reinitializeOnClick || false;
        self.initDatepicker();

      }

      self.$onChanges = function (e) {
        self.language == '' ? self.lang = 'it' : self.lang = self.language;
        //self.updateDatepicker();
        if ((e.startDate && e.startDate.currentValue || e.endDate && e.endDate.currentValue) && self.reinitializeOnClick) {
          self.initDatepicker();
        }

      }

      self.isDateEnabled = function (date) {
        var disabledDates = self.disabledDates || [];
        var day = (date.getDate() < 10) ? ("0" + date.getDate()) : date.getDate();
        var month = date.getMonth() + 1;
        month = (month < 10) ? ("0" + month) : month;
        var date = day + '-' + month;
        if (disabledDates.indexOf(date) != -1)
          return false;
        else
          return true;
      }

      self.initDatepicker = function () {
        $('.input-group.date#' + self.inputId).datepicker('destroy');
        if (self.disableHolidays) {
          var disabledDates = self.disabledDates || [];
          var lang = self.lang;
          var startDate = self.startDate;
          var endDate = self.endDate;
          var disabledDates = self.disabledDates;
          var disabledDays = self.disabledDays;
          var isDateEnabled = self.isDateEnabled;
          var options = {
            weekStart: 1,
            language: lang,
            autoclose: true,
            todayHighlight: true,
            startDate: startDate,
            endDate: endDate,
            datesDisabled: disabledDates,
            daysOfWeekDisabled: disabledDays,
            assumeNearbyYear: moment().format("YYYY"),
            immediateUpdates: true,
            templates: {
              leftArrow: '<i class="fa fa-caret-left"></i>',
              rightArrow: '<i class="fa fa-caret-right"></i>'
            },
            format: 'dd/mm/yyyy',
            beforeShowDay: function (date) {
              return isDateEnabled(date);
            }
          };

          $timeout(function () {
            $('.input-group.date#' + self.inputId).datepicker(options)
              .on('paste', function (e) {
                var pastedData = e.originalEvent.clipboardData.getData('text');
                $timeout(function () {
                  self.bindingVariable = pastedData;
                  self.dataChanged();
                }, 500)
              });
          }, 0)
        } else {
          $timeout(function () {
            $('.input-group.date#' + self.inputId).datepicker({
              weekStart: 1,
              language: self.lang,
              autoclose: true,
              todayHighlight: true,
              startDate: self.startDate,
              endDate: self.endDate,
              datesDisabled: self.disabledDates,
              daysOfWeekDisabled: self.disabledDays,
              assumeNearbyYear: moment().format("YYYY"),
              immediateUpdates: true,
              templates: {
                leftArrow: '<i class="fa fa-caret-left"></i>',
                rightArrow: '<i class="fa fa-caret-right"></i>'
              },
              format: 'dd/mm/yyyy'
            })
              .on('paste', function (e) {
                var pastedData = e.originalEvent.clipboardData.getData('text');
                $timeout(function () {
                  self.bindingVariable = pastedData;
                  self.dataChanged();
                }, 500)

              });
          }, 0);
        }
      }

      self.dataChanged = function () {
        checkDate();
        if (self.bindingVariable == null) {
          self.changeData({
            newData: self.bindingVariable
          })
        } else {
          if (self.bindingVariable.length == 10) {
            self.changeData({
              newData: moment(self.bindingVariable, "DD/MM/YYYY").format("DD/MM/YYYY")
            })
            if (self.formName && self.inputName && self.formName[self.inputName]) {
              self.formName[self.inputName].$setValidity("text", true);
            }
          } else {
            if (self.formName && self.inputName && self.formName[self.inputName]) {
              self.formName[self.inputName].$setValidity("text", false);
            }
          }


        }

      }

      var checkDate = function () {
        var timeOfCurrentdate = 0;
        if (self.endDate) {
          var timeOfEndDate = moment(self.endDate, "DD/MM/YYYY").toDate().getTime();
        }
        if (self.startDate) {
          var timeOfStartDate = moment(self.startDate, "DD/MM/YYYY").toDate().getTime();
        }
        if (!self.dataRegex.test(self.bindingVariable)) {
          self.bindingVariable = null;
        }
        if (self.disabledDates.length && self.bindingVariable) {
          var tempDate = self.bindingVariable
            .replace(/\//g, "-")
            .substring(0, 5)
          self.disabledDates.forEach(function (element) {
            if (element == tempDate) {
              self.bindingVariable = null;
            }
          })
        }
        if (self.bindingVariable && (self.bindingVariable.length == 10)) {
          timeOfCurrentdate = moment(self.bindingVariable, "DD/MM/YYYY").toDate().getTime()

          var dayOfWeekTest = self.disabledDays && self.disabledDays.findIndex(function (element) {
            return element == moment(self.bindingVariable, "DD/MM/YYYY").day();
          });

          if (self.disabledDays.length && dayOfWeekTest >= 0) {
            self.bindingVariable = null
          }



          if (self.endDate && timeOfEndDate) {
            if (self.restrictData && timeOfCurrentdate >= timeOfEndDate) {
              self.bindingVariable = null
            } else if (!self.restrictData && timeOfCurrentdate > timeOfEndDate) {
              self.bindingVariable = null
            }

          }
          if (self.startDate && timeOfStartDate && timeOfCurrentdate < timeOfStartDate) {
            self.bindingVariable = null
          }
        }
      }
    }
  });